var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LanguageSwitch from './LanguageSwitch';
import { Box } from '@mui/material';
import i18n from '../i18n';
import { convertLanguage } from '../utils/languageUtils';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  margin: 20px 0;\n\n  a {\n    color: #333;\n    display: block;\n  }\n"], ["\n  text-align: center;\n  margin: 20px 0;\n\n  a {\n    color: #333;\n    display: block;\n  }\n"])));
var SessionLinks = function (_a) {
    var role = _a.role, showLogin = _a.showLogin, showResetPassword = _a.showResetPassword, showReconfirmEmail = _a.showReconfirmEmail;
    var t = useTranslation().t;
    var convertedLanguage = convertLanguage(i18n.language);
    return (React.createElement(Wrapper, null,
        showLogin && React.createElement(Link, { to: "/".concat(role, "/login") }, t('links.login')),
        showResetPassword && (React.createElement(Link, { to: "/".concat(role, "/password/reset") }, t('links.resetPassword'))),
        showReconfirmEmail && (React.createElement(Link, { to: "/".concat(role, "/email/reconfirm") }, t('links.reconfirmEmail'))),
        React.createElement(LanguageSwitch, null),
        React.createElement(Box, { sx: {
                mt: 5,
                color: 'red',
            } },
            React.createElement(Trans, { i18nKey: "messages.newPlatformRegisterNotice" },
                React.createElement("a", { href: "https://typica.coffee/".concat(convertedLanguage, "/sign-up"), target: "_blank", rel: "noopener noreferrer", style: { color: 'red', display: 'inline' } })))));
};
SessionLinks.defaultProps = {
    showLogin: false,
    showRegister: false,
    showResetPassword: false,
};
export default SessionLinks;
var templateObject_1;
